import { storageKeys } from '../constants';
import { initialFilterFemale } from 'helpers';
import {
  TActivityArea,
  TFilterFemale,
  TFilterOptions,
  TPaymentPending,
  TResFemaleRanking,
} from 'types';
import { create } from 'zustand';
import { StateSnapshot } from 'react-virtuoso';

const filterLocal = localStorage.getItem(storageKeys.FILTER_FEMALE);

type State = {
  filterOptions?: TFilterOptions;
  filterFemale: TFilterFemale;
  searchScrollY: number;
  paymentPending: TPaymentPending;
  activityAreas: TActivityArea[];
  franchiseAreas: TActivityArea[];
  overallRankings: TResFemaleRanking[];
  messageVirtuosoState?: StateSnapshot | null;
};

type Actions = {
  setFilterOptions: (values: TFilterOptions) => void;
  setFilterFemale: (values: TFilterFemale) => void;
  setSearchScrollY: (value: number) => void;
  setPaymentPending: (value: TPaymentPending) => void;
  setActivityAreas: (value: TActivityArea[]) => void;
  setOverallRankings: (value: TResFemaleRanking[]) => void;
  setMessageVirtuosoState: (value?: StateSnapshot | null) => void;
};

const useAppStore = create<State & Actions>((set) => ({
  activityAreas: [],
  franchiseAreas: [],
  filterOptions: undefined,
  listPendingPayment: [],
  lastFetchPaymentTime: 0,
  paymentPending: {
    ids: [],
    lastFetchingTime: 0,
  },
  filterFemale: filterLocal ? JSON.parse(filterLocal) : initialFilterFemale,
  searchScrollY: 0,
  overallRankings: [],
  messageVirtuosoState: null,
  setFilterOptions: (values: TFilterOptions) =>
    set(() => ({
      filterOptions: values,
    })),
  setFilterFemale: (values: TFilterFemale) => {
    localStorage.setItem(storageKeys.FILTER_FEMALE, JSON.stringify(values));
    set(() => ({
      filterFemale: values,
    }));
  },
  setSearchScrollY: (value: number) => {
    set(() => ({ searchScrollY: value }));
  },
  setPaymentPending: (value: TPaymentPending) => {
    set(() => ({ paymentPending: value }));
  },
  setActivityAreas: (value: TActivityArea[]) => {
    set(() => ({
      activityAreas: value,
      franchiseAreas: value?.filter((area) => !!area?.franchiseId),
    }));
  },
  setOverallRankings: (value: TResFemaleRanking[]) => {
    set(() => ({ overallRankings: value }));
  },
  setMessageVirtuosoState: (value?: StateSnapshot | null) => {
    set(() => ({ messageVirtuosoState: value ?? null }));
  },
}));

export default useAppStore;
